var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88273 9.91905C3.38215 7.16608 5.05312 4.4445 7.79239 3.87366C13.4864 2.68709 17.8391 2.7334 23.2136 3.86534C25.9503 4.44173 27.6175 7.16418 27.1171 9.91578L24.7165 23.118C24.3276 25.2567 22.7013 26.98 20.5692 27.4042C16.4273 28.2283 14.6174 28.1765 10.5026 27.3786C8.33647 26.9586 6.66589 25.2251 6.27114 23.0541L3.88273 9.91905Z",
    stroke: "#2E2E2F",
    strokeWidth: 2.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5165 15.0134L10 15.0134",
    stroke: "#2E2E2F",
    strokeWidth: 2.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5165 15.0134L15.987 11",
    stroke: "#2E2E2F",
    strokeWidth: 2.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5165 15.0134L15.987 19.0268",
    stroke: "#2E2E2F",
    strokeWidth: 2.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmt);
export default __webpack_public_path__ + "static/media/tmt.c45c7814a72bdc9b9b814ca7e1d7e1f7.svg";
export { ForwardRef as ReactComponent };